export const environment = {
    production: false,
    baseHref: '/',
    domain_url: '/',
    api_url: 'https://drci5ihael.execute-api.us-west-1.amazonaws.com/dev/rr',
    slug:"landingpage"
};